import Loadable from 'react-loadable'

const DesktopTrending = Loadable({
    loader: () => import(/* webpackChunkName: "desktopTrending" */ './trending'),
    loading: () => null,
})

const TrendingRoute = () => <DesktopTrending />

export default TrendingRoute
